"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
var Language;
(function (Language) {
    Language["Expression"] = "expression";
    Language["JavaScript"] = "javascript";
    Language["TypeScript"] = "typescript";
    Language["JSON"] = "json";
    Language["Html"] = "html";
    Language["PlainText"] = "plaintext";
})(Language || (exports.Language = Language = {}));
